import clsx from 'clsx'
import './ui.css'

export interface SegmentedOption<T extends string> {
  value: T
  label: string
  sub?: string
}

/**
 * A radiogroup rendered as a segment strip. Used for the cat's sex, which is
 * always a human decision — the AI never populates it.
 */
export function Segmented<T extends string>({
  options,
  value,
  onChange,
  label,
  className,
}: {
  options: ReadonlyArray<SegmentedOption<T>>
  value: T
  onChange: (v: T) => void
  label: string
  className?: string
}) {
  return (
    <div className={clsx('segmented', className)} role="radiogroup" aria-label={label}>
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          role="radio"
          aria-checked={value === o.value}
          className="segmented__option"
          onClick={() => onChange(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  )
}

export function Switch({
  checked,
  onChange,
  title,
  description,
  disabled,
}: {
  checked: boolean
  onChange: (v: boolean) => void
  title: string
  description?: string
  disabled?: boolean
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      className="switch"
      disabled={disabled}
      onClick={() => onChange(!checked)}
    >
      <span className="switch__text">
        <span className="switch__title">{title}</span>
        {description && <span className="switch__desc">{description}</span>}
      </span>
      <span className="switch__track" data-on={checked}>
        <span className="switch__knob" />
      </span>
    </button>
  )
}
